import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const AuthCard = ({
  title, subtitle, subtitle2, hasError, children,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: '#FFFFFF',
      border: '1px solid #D1D5DC',
      borderRadius: '16px',
      boxShadow: '0px 12px 40px rgba(26, 50, 97, 0.12)',
      pt: '0px',
      pb: '40px',
      px: { xs: '24px', sm: '60px' },
      width: '100%',
      maxWidth: '860px',
      minHeight: '150px',
      maxHeight: '90vh',
      overflowY: 'auto',
      boxSizing: 'border-box',
      ml: { xs: '0px', md: '100px' },
      mb: '16px',
    }}
  >
    {title && (
      <Typography sx={{
        color: '#000000',
        fontSize: 32,
        fontWeight: 700,
        fontFamily: 'Open Sans',
        textAlign: 'center',
        mb: '8px',
        mt: '20px',
      }}
      >
        {title}
      </Typography>
    )}

    {subtitle && (
      <Typography sx={{
        color: hasError ? '#EF456E' : '#717182',
        fontSize: '16px',
        fontFamily: 'Open Sans',
        fontWeight: 500,
        mt: '4px',
        maxWidth: '500',
        lineHeight: '1.5',
        textAlign: 'center',
      }}
      >
        {subtitle}
      </Typography>
    )}

    {subtitle2 && (
      <Typography sx={{
        color: hasError ? '#EA2027' : '#242222',
        fontSize: '14px',
        textAlign: 'center',
        mt: '3px',
        mb: '8px',
      }}
      >
        {subtitle2}
      </Typography>
    )}

    {children}
  </Box>
);

AuthCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle2: PropTypes.string,
  hasError: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

AuthCard.defaultProps = {
  title: undefined,
  subtitle: undefined,
  subtitle2: undefined,
  hasError: false,
};

export default AuthCard;
